import cssVars from 'css-vars-ponyfill';
cssVars();



// WEBPACK FOOTER //
// ./scripts/vendors/_css-vars-ponyfill.js